var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Active & Legging Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Active & Legging Line",
      "file": "active"
    }
  }, [_vm._v(" 프린팅과 포일 디자인을 더한 싱글/더블 니트, 다양한 패턴의 엠보싱, 고신축성과 리커버리를 가진 아이템. 스포츠 및 레깅스 아이템에 대해 경험이 풍부하며 합리적인 가격으로 많은 브랜드와 협력하고 있습니다. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }